import React from 'react'
import Vision from '../../container/company/vision'

const VisionPage = (props) => (
  <Vision {...props} langKey='it' />
)

export default VisionPage
